export function bytesToGi(bytes: number): number {
  return Number((bytes / (1024 * 1024 * 1024)).toFixed(4));
}
